import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDebugStore = defineStore('pinia/debugMode', () => {
  const debugMode = ref(false)
  const turnOnDebugMode = () => {
    debugMode.value = true
  }
  const turnOffDebugMode = () => {
    debugMode.value = false
  }

  return { debugMode, turnOnDebugMode, turnOffDebugMode }
})
